import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';
import { INPUT_DATA_OBJECT_ROUTES } from './InputDataObjects';
import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectCreate } from '../data-objects/DataObjectCreate';

export const InputDataObjectCreate = () => {
  const { handleSuccess, handleCancel } = useDataObjectActionHandlers(
    'inputDataObjectView'
  );

  return (
    <DataObjectCreate
      routes={INPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.IN}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};
